// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2yhJc","layout":"styles_layout__StAsC","text":"styles_text__feiFe","title":"styles_title__2IpNg"};